export const YMME_NAME = 'MainYmme'
